// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/live-axios';
import { dispatch } from '../index';

// types
import { DefaultRootStateProps } from 'types';

// ----------------------------------------------------------------------

const initialState: DefaultRootStateProps['notificationTrigger'] = {
	error: null,
	notificationTriggers: [],
};

const slice = createSlice({
	name: 'notificationTrigger',
	initialState,
	reducers: {
		hasError(state, action) {
			state.error = action.payload;
		},

		getNotificationTriggerSuccess(state, action) {
			state.notificationTriggers = action.payload;
		},
	},
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export const notificationTriggerApi = {
	getAll: () => async () => {
		try {
			const response = await axios.get('/notification/trigger');
			dispatch(slice.actions.getNotificationTriggerSuccess(response.data));
		} catch (error) {
			dispatch(slice.actions.hasError(error));
		}
	},
};
